angular.module("cadastralDocs.components", []).component("cadastralDocs", {
    templateUrl: "ng/components/cadastralDocSubscription/cadastralDocs/cadastralDocs.view.html",
    bindings: {
        richiestePostVendita: "=",
        validatePage: "&"
    },
    controllerAs: "cadastralDocsCtrl",
    controller: function CadastralDocs(
        $rootScope,
        $arcService,
        $userService,
        $timeout,
        Sede,
        DettaglioImmobiliare,
        DatiCatastali
    ) {
        var self = this;

        var initProvince = function () {
            self.supportModel.dropdown.province = $rootScope.comuniMap
                .map(function (comune) {
                    return comune.sigla;
                })
                .filter(function (siglaComune) {
                    return siglaComune != "";
                })
                .sort()
                .reduce(function (result, nextItem) {
                    return result.includes(nextItem) ? result : result.concat(nextItem);
                }, []);
        };

        //onChange sulle province
        self.getCaps = function (comune) {
            var found = comune.cap;
            self.supportModel.dropdown.caps = found || [];
        };

        self.$onInit = function () {
            self.maxLengthInputBox = 120;
            self.supportModel = {
                contractSelected: [],
                contractList: [],
                dettaglioImmList: [],
                dropdown: {
                    province: [],
                    comuni: [],
                    caps: []
                },
                emittente: self.richiestePostVendita.metadata.sottoscrizioneCatastale.provvedimento.emittente.nome,
                dettaglioList: []
            }
            self.supportModel.sottoscrizioneCatastale = self.richiestePostVendita.metadata.sottoscrizioneCatastale;
            self.supportModel.listToUpdate = self.supportModel.sottoscrizioneCatastale.contratti;

            self.supportModel.listToUpdate.forEach(function (element) {
                if (element.dettaglioImmobiliare.length) {
                    element.selected = true;
                    self.supportModel.dettaglioList = element.dettaglioImmobiliare;
                } else {
                    getDettaglioReddito();
                }
            });

            if(!self.supportModel.sottoscrizioneCatastale.email){
                getAppUser();
            }

            initProvince();
            checkValidityPage();
            $timeout(function () {
                self.enableTooltip = true;
            }, 500)
        };

        self.getComuni = function (provincia) {
            self.supportModel.dropdown.comuni = $rootScope.comuniMap
                .filter(function (comune) {
                    return comune.sigla == provincia;
                });
        };

        self.exportValiditySede = function (validity) {
            self.validitySede = validity;
        }

        self.handleChange = function (property, value) {
            switch (property) {
                case "nominativo":
                case "email":
                    self.supportModel.sottoscrizioneCatastale.tecnicoIncaricato[property] = value;
                    break;
                case "descrizioneModifiche":
                case "nuovaCategoriaCatastale":
                case "destImmobiliVariato":
                    self.supportModel.sottoscrizioneCatastale[property] = value;
                    break;
                case "tipo":
                case "numero":
                case "data":
                    self.supportModel.sottoscrizioneCatastale.provvedimento[property] = value;
                    break;
                case "emittente":
                    if (self.supportModel.sottoscrizioneCatastale.provvedimento.emittente.nome) {
                        self.supportModel.sottoscrizioneCatastale.provvedimento.emittente.nome = self.supportModel.emittente;
                    } else {
                        self.supportModel.sottoscrizioneCatastale.provvedimento.emittente.nome = self.supportModel.emittente;
                    }
                    break;
                case "indirizzoDocumentazione":
                    self.supportModel.sottoscrizioneCatastale.indirizzoDocumentazione = value;
                    break;
                case "doc":
                    self.supportModel.sottoscrizioneCatastale.documentazione = value;
                    break;
                case "dettaglio":
                    self.supportModel.listToUpdate.forEach(function (contratto) {
                        value.forEach(function (dettaglio) {
                            //se c'è almeno un dettaglio selezionato, contratto.selected = true 
                            if (dettaglio.numero == contratto.numero &&
                                dettaglio.modulo == contratto.modulo &&
                                dettaglio.selected) {
                                contratto.selected = true;
                                contratto.dettaglioImmobiliare = value;
                            }
                        });
                    });
                    break;
                case "immoDestination":
                    if (!value) {
                        self.supportModel.sottoscrizioneCatastale.nuovaCategoriaCatastale = "";
                    }
                    break;
                case "emailContatto":
                    self.supportModel.sottoscrizioneCatastale.email = value;
                    break;
                default:
                    break;
            }
            checkValidityPage();
        }

        var getDettaglioReddito = function () {
            self.isPending = true;
            self.supportModel.listToUpdate.forEach(function (contratto) {
                $arcService.
                getDettaglioReddito(contratto.numero, contratto.modulo)
                    .then(function (response) {
                        if (response) {
                            response.dettaglioImmobiliare.forEach(function (element) {
                                var dettaglio = DettaglioImmobiliare.build();
                                dettaglio.numero = contratto.numero;
                                dettaglio.modulo = contratto.modulo;
                                dettaglio.indirizzo = Sede.build(element.indirizzo);
                                dettaglio.datiCatastali = DatiCatastali.build(element.datiCatastali);
                                self.supportModel.sottoscrizioneCatastale.attualeCategCatastale = element.datiCatastali.categoriaCatastale;
                                dettaglio.selected = true;
                                contratto.dettaglioImmobiliare.push(dettaglio);
                            });
                            self.supportModel.dettaglioList = contratto.dettaglioImmobiliare;
                            self.isPending = false;
                        }
                    })
            })
            checkValidityPage();
        }

        var checkValidityPage = function () {
            var sottoscrizione = self.supportModel.sottoscrizioneCatastale.tecnicoIncaricato.nominativo &&
                self.supportModel.sottoscrizioneCatastale.tecnicoIncaricato.email &&
                self.supportModel.sottoscrizioneCatastale.descrizioneModifiche &&
                self.supportModel.sottoscrizioneCatastale.provvedimento.tipo &&
                self.supportModel.sottoscrizioneCatastale.provvedimento.numero &&
                self.supportModel.sottoscrizioneCatastale.provvedimento.data &&
                self.supportModel.sottoscrizioneCatastale.provvedimento.emittente.nome && 
                self.supportModel.sottoscrizioneCatastale.email;

            var catCatastale = false;
            if (self.supportModel.sottoscrizioneCatastale.destImmobiliVariato) {
                catCatastale = self.supportModel.sottoscrizioneCatastale.nuovaCategoriaCatastale;
            } else {
                catCatastale = true;
            }
            var indirizzoDoc = self.validitySede;

            var dettaglioImmo = false;
            self.supportModel.sottoscrizioneCatastale.contratti.forEach(function (contratto) {
                dettaglioImmo = contratto.dettaglioImmobiliare.some(function (dettaglio) {
                    return dettaglio.selected == true
                });
            });

            if (sottoscrizione && indirizzoDoc && dettaglioImmo && catCatastale) {
                self.validatePage({
                    validity: true
                });

                self.supportModel.sottoscrizioneCatastale.contratti = self.supportModel.listToUpdate;
                self.richiestePostVendita.metadata.sottoscrizioneCatastale = self.supportModel.sottoscrizioneCatastale;
            } else {
                self.validatePage({
                    validity: false
                });
            }
        }

        var getAppUser = function () {
            $userService.
            getAppUser()
                .then(function (response) {
                    self.supportModel.sottoscrizioneCatastale.email = response.email;
                }).catch(function (error) {
                    console.log(error);
                })
        }
    }
});